module.exports = __webpack_public_path__ + "static/media/Contact - eMail.b8871fbf.svg";